import { render, staticRenderFns } from "./AgentsPage.vue?vue&type=template&id=206e9bf6&"
import script from "./AgentsPage.vue?vue&type=script&lang=js&"
export * from "./AgentsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports